import { StyledFontAwesomeIcon } from "pstat-anywhere/components/partials/icons";
import RouterFocusLink from "pstat-design-system/RouterFocusLink";
import { Text } from "pstat-design-system/text/paragraph";

const Breadcrumb = ({ id, text, to }) => (
  <RouterFocusLink id={id} to={to} mt={4} mb={1}>
    <StyledFontAwesomeIcon icon={["far", "chevron-left"]} ml={0} />
    <Text fontWeight="medium" fontSize={1} color="nav.25">
      {text}
    </Text>
  </RouterFocusLink>
);

export default Breadcrumb;
